import Vue from "vue";
import Vuex from "vuex";
import PortalVue from "portal-vue";
import NProgress from "nprogress";
import VTooltip from "v-tooltip";
import "nprogress/nprogress.css";

// veelidate
import { required, email, is } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

import Notifications from "vue-notification";
import App from "./App.vue";

import i18n from "./i18n";
import store from "./store";

import VueInputAutowidth from "vue-input-autowidth";

import router from "./router.js";

Vue.use(Vuex);
Vue.use(VueInputAutowidth);
Vue.use(PortalVue);
Vue.use(VTooltip);
Vue.use(Notifications);

//global  mixins
// Vue.mixin($tMixin);
Vue.prototype.$NProgress = NProgress;

// veelidate rules

function addValidationRules() {
	extend("required", {
		...required,
		message: "Este campo é obrigatório",
	});

	extend("email", {
		...email,
		message: "O endereço de email é inválido",
	});

	extend("is", {
		...is,
		message: "Os campos não coincidem",
	});

	function hasMinLength(val) {
		return val.length >= 8;
	}
	function hasUppercase(val) {
		return /[A-Z]/.test(val);
	}

	function hasLowercase(val) {
		return /[a-z]/.test(val);
	}

	function hasSpecialChar(val) {
		/* eslint-disable-next-line */
		const regex = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
		return regex.test(val);
	}
	function hasNumber(val) {
		return /[0-9]/.test(val);
	}

	extend("strong_password", {
		validate: (val) => {
			return (
				hasMinLength(val) &&
				hasUppercase(val) &&
				hasLowercase(val) &&
				hasSpecialChar(val) &&
				hasNumber(val)
			);
		},
		message:
			"A senha deve conter no mínimo 8 caracteres, uma letra minúscula, uma letra maiúscula, um número e um caractére especial",
	});
}

addValidationRules();

//global vars
Vue.config.productionTip = false;

//init app
store.dispatch("user/initAuth");

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
